import React from 'react'

const TotalSalesDailyShift = ({ row }) => {
  return <div>{row?.totalSales.toLocaleString()}</div>;
};

export default TotalSalesDailyShift;